import type { ClientOrganizationProfileRoleEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';

type Variables = {
  organizationId: string;
  email: string;
  roleKey: ClientOrganizationProfileRoleEnum;
};

export const useAddOrganizationMember = () => {
  const api = useGrapevineOrganizationApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationId, email, roleKey }: Variables) =>
      api.addOrganizationMember({
        organizationId,
        clientOrganizationMemberAddRequest: { email: email.trim(), roleKey }
      }),
    onSuccess: (_data, { organizationId }) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATION_MEMBERS, organizationId]
      });
      // The added person's own-organization list gains this org.
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_ORGANIZATIONS]
      });
      // Membership changes can affect available creation senders.
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
      // The organization detail embeds its members.
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATION, organizationId]
      });
    }
  });
};
